import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { shortDate } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Plus, GraduationCap, Users } from "lucide-react";

export default function TrainingReports() {
  const [reports, setReports] = useState([]);
  const [agents, setAgents] = useState([]);
  const [agentId, setAgentId] = useState("");
  const { user } = useAuth();
  const isAdmin = ["super_admin", "management", "general_manager"].includes(user?.role);

  useEffect(() => {
    if (isAdmin) api.get("/agents").then(r => setAgents(r.data)).catch(() => {});
  }, [isAdmin]);
  useEffect(() => {
    api.get("/training-reports", { params: agentId ? { agent_id: agentId } : {} }).then(r => setReports(r.data));
  }, [agentId]);

  return (
    <div className="space-y-6" data-testid="training-page">
      <div className="flex justify-between items-end flex-wrap gap-3">
        <div>
          <h1 className="text-2xl sm:text-4xl font-heading font-black tracking-tight">Training Reports</h1>
          <p className="text-slate-600 mt-1">{reports.length} sessions logged</p>
        </div>
        <div className="flex gap-2">
          {isAdmin && (
            <select value={agentId} onChange={(e) => setAgentId(e.target.value)} className="h-11 px-3 border border-slate-300 rounded-lg" data-testid="training-agent-filter">
              <option value="">All Agents</option>
              {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          )}
          <Link to="/training/new" className="mlily-btn h-11 px-5 rounded-lg font-semibold flex items-center gap-2" data-testid="new-training-btn"><Plus className="w-4 h-4" /> New</Link>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.map(r => (
          <div key={r.id} className="bg-white rounded-xl border border-slate-200 p-5 card-hoverable" data-testid={`training-card-${r.id}`}>
            <div className="flex justify-between">
              <GraduationCap className="w-6 h-6 text-[#003DA5]" />
              <div className="text-xs text-slate-500">{shortDate(r.training_date)}</div>
            </div>
            <div className="mt-3 text-lg font-heading font-semibold">{r.customer_name}</div>
            <div className="text-xs text-slate-500">{r.training_topic}</div>
            <div className="mt-3 text-xs text-slate-600 line-clamp-2">{r.feedback_received || r.agent_notes || "—"}</div>
            <div className="mt-3 pt-3 border-t border-slate-100 flex justify-between text-xs">
              <span className="flex items-center gap-1 text-slate-500"><Users className="w-3 h-3" /> {r.number_of_attendees || 0} attendee{r.number_of_attendees !== 1 ? "s" : ""}</span>
              <span className="text-slate-500">{r.agent_name}</span>
            </div>
          </div>
        ))}
        {reports.length === 0 && <div className="col-span-full text-center text-slate-500 py-16">No training reports yet.</div>}
      </div>
    </div>
  );
}
